// 埋点上报
import { apiPost } from './index'

// 埋点上报
const traceApi = (params) => apiPost(`/api/logs/type/${params.incidentType}`, params)

// 直播二维码分享轮询埋点
const shareLogApi = (params) => apiPost('/api/logs/share', params)

// 埋点上报视频播放时长
const traceVideoDuration = (params) => apiPost(`/api/course/completed/records/addPlayDuration/${params.videoId}`, params)

// session表录入
const uploadSession = (params) => apiPost(`/api/session`, params)

// 搜索埋点接口
const userSearchLog = (params) => apiPost(`/api/userSearchLog/saveSearch`, params)

// 功能点击埋点
const userFunction = (params) => apiPost(`/api/user-function`, params)

export {
  traceApi,
  shareLogApi,
  traceVideoDuration,
  uploadSession,
  userSearchLog,
  userFunction
}



// WEBPACK FOOTER //
// ./src/api/trace.js